import React, { useState } from 'react'
import * as importAPI from '../services/import'

const ImportJSON = ({ onImportComplete }) => {
  const [isImporting, setIsImporting] = useState(false)
  const [pastedText, setPastedText] = useState('')

  const performImport = async (getText) => {
    setIsImporting(true)
    try {
      const text = await Promise.resolve(getText())
      // importFromJSON may be synchronous or return a Promise, so normalize with Promise.resolve
      const result = await Promise.resolve(importAPI.importFromJSON(text))

      if (result && result.success) {
        alert('Import completed successfully.')
        if (typeof onImportComplete === 'function') onImportComplete()
      } else {
        // If importFromJSON didn't return success, attempt to validate to provide a clearer message.
        const validation = await Promise.resolve(importAPI.validateJSON(text))
        const msg = validation && validation.error ? validation.error : 'Plik JSON jest nieprawidłowy.'
        alert('Import failed: ' + msg)
      }
    } catch (err) {
      alert('Error importing file: ' + (err && err.message ? err.message : String(err)))
    } finally {
      setIsImporting(false)
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return

    await performImport(async () => await file.text())
    // clear the input so the same file can be selected again if needed
    e.target.value = null
  }

  const handlePasteImport = async () => {
    if (!pastedText || !pastedText.trim()) {
      alert('Wklej JSON do pola tekstowego przed importem.')
      return
    }
    await performImport(() => pastedText)
    setPastedText('')
  }

  return (
    <div className="import-json">
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <input type="file" accept="application/json" onChange={handleFileChange} />
          {isImporting && <span>Importing...</span>}
        </label>

        <div style={{ maxWidth: '100%' }}>
          <textarea
            rows="10"
            cols="60"
            placeholder="Wklej tutaj zawartość pliku JSON i kliknij 'Importuj wklejony JSON'..."
            value={pastedText}
            onChange={(e) => setPastedText(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box' }}
          />
          <div style={{ marginTop: 8 }}>
            <button onClick={handlePasteImport} disabled={isImporting}>
              {isImporting ? 'Importowanie...' : 'Importuj wklejony JSON'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportJSON
